@if (isBuildingConsultant) {
    <h3 class="mat-headline-6 cb-margin cb-margin-left-3x">{{ getTitle() }}</h3>
}
<mat-tab-group
    [(selectedIndex)]="selectedTabIndex"
    [cbTabRoute]="LEADS_ROUTE"
    mat-stretch-tabs="false"
    defaultTabId="details"
>
    <mat-tab label="Details" cbTabRouteId="details">
        <form #leadEditForm="ngForm">
            <cb-lead-view
                *cbWaitFor="mappedItem"
                (leadChanged)="updateLead($event)"
                [mappedItem]="mappedItem"
                [canEdit]="canEditLead()"
            >
            </cb-lead-view>
        </form>
    </mat-tab>
    @if (canViewTasks()) {
        <mat-tab label="Tasks" cbTabRouteId="tasks">
            <ng-template matTabContent>
                <cb-tasks
                    class="flex-col flex"
                    *cbWaitFor="mappedItem"
                    [entity]="mappedItem"
                    [edit]="mappedItem.isHotOrCold()"
                    [permissions]="taskPermissions"
                >
                </cb-tasks>
            </ng-template>
        </mat-tab>
    }
    @if (canViewNotes()) {
        <mat-tab label="Notes" cbTabRouteId="notes">
            <ng-template matTabContent>
                <cb-notes
                    *cbWaitFor="mappedItem"
                    [entity]="mappedItem"
                    [edit]="true"
                    [permissions]="notePermissions"
                >
                </cb-notes>
            </ng-template>
        </mat-tab>
    }
    @if (canViewDocuments()) {
        <mat-tab label="Documents" cbTabRouteId="documents">
            <ng-template matTabContent>
                <cb-document
                    *cbWaitFor="mappedItem"
                    [entity]="mappedItem"
                    [permissions]="documentPermissions"
                    [includeLinked]="true"
                    [systemArea]="systemArea"
                >
                </cb-document>
            </ng-template>
        </mat-tab>
    }
    @if (canViewHistory()) {
        <mat-tab label="History" cbTabRouteId="history">
            <ng-template matTabContent>
                <cb-history-list
                    *cbWaitFor="mappedItem"
                    [entityId]="mappedItem?.id"
                    [entity]="HISTORY_SEARCH_ENTITY.Lead"
                >
                </cb-history-list>
            </ng-template>
        </mat-tab>
    }
</mat-tab-group>
